import { render, staticRenderFns } from "./ActualPaperDetail.vue?vue&type=template&id=5dfbdb61&scoped=true&"
import script from "./ActualPaperDetail.vue?vue&type=script&lang=js&"
export * from "./ActualPaperDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActualPaperDetail.vue?vue&type=style&index=0&id=5dfbdb61&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfbdb61",
  null
  
)

export default component.exports